export default {
  // -----------------------------------------------------------------------------
  // Common translation entries
  // -----------------------------------------------------------------------------

  /* Nouns, Types, Terms, Phrases, etc... */
  filters: 'Filters',
  actions: 'Actions',
  status: 'Status',
  additional_info: 'Additional info',
  search_placeholder_default: 'Search…',

  /* Verbs */
  remove: 'Remove',
  follow: 'Follow',
  unfollow: 'Unfollow',
  add: 'Add',
  cancel: 'Cancel',
  try_again: 'Try again',
  update: 'Update',
  submit: 'Submit',
  edit: 'Edit',
  preview: 'Preview',
  delete: 'Delete',
  close: 'Close',
  activate: 'Activate',
  expand: 'Expand',
  collapse: 'Collapse',
  accept: 'Accept',
  clear: 'Clear',
  use: 'Use',
  undo: 'Undo',
  redo: 'Redo',

  /* Static verb noun */
  view_all: 'View all',
  view_less: 'View less',
  show_more: 'Show more',
  show_less: 'Show less',
  clear_all: 'Clear all',
  link_open_in_tab_text: 'Open in tab',
  edit_details: 'Edit details',
  add_emoji: 'Add emoji',

  /* Dynamic verb {noun} */
  close_noun: 'Close: {0}',
  view_all_noun: 'View all: {0}',
  view_less_noun: 'View less: {0}',
  expand_noun: 'Expand: {0}',
  add_noun: 'Add: {0}',
  collapse_noun: 'Collapse: {0}',
  checked_noun: '{0}: checked',
  selected_noun: '{0}: selected',
  deselected_noun: '{0}: unselected',
  use_input_value: 'Use {0}',
  preview_of_noun: 'Preview of: {0}',

  /* States */
  edited: 'Edited',
  done: 'Done',
  uploading: 'Uploading',
  loading: 'Loading…',
  submitting: 'Submitting…',
  no_items: 'No items',
  unknown_error: 'Unknown error',
  image_load_error: 'Error loading image',
  selected: 'Selected',

  /* Date and time */
  day_label_a11y: 'Day',
  day_placeholder: 'DD',
  quarter_label_a11y: 'Quarter',
  month_label_a11y: 'Month',
  month_placeholder: 'MM',
  year_label_a11y: 'Year',
  year_placeholder: 'YYYY',
  hour_label_a11y: 'Hour',
  hour_placeholder: 'hh',
  minute_label_a11y: 'Minute',
  minute_placeholder: 'mm',
  second_label_a11y: 'Second',
  second_placeholder: 'ss',
  meridiem_label_a11y: 'Meridiem',
  meridiem_value_am: 'AM',
  meridiem_value_pm: 'PM',
  week_label_a11y: 'Week',
  week_placeholder: 'ww',
  week_text: 'Week',
  seconds_text: 'Seconds',
  minutes_text: 'Minutes',
  hours_text: 'Hours',
  days_text: 'Days',
  time_text: 'Time',
  time_format_info: 'hh:mm:ss',
  week_text_short: 'Wk',
  day_text_short: 'd',
  hour_text_short: 'h',
  minute_text_short: 'm',
  second_text_short: 's',
  date_quarter_q1: 'Q1 {0}',
  date_quarter_q2: 'Q2 {0}',
  date_quarter_q3: 'Q3 {0}',
  date_quarter_q4: 'Q4 {0}',

  /* Count based types */
  attachments_count: {
    zero: 'No attachments',
    one: '{0} attachment',
    two: '{0} attachments',
    few: '{0} attachments',
    many: '{0} attachments',
    other: '{0} attachments'
  },
  results_count: {
    zero: 'No results',
    one: '{0} result',
    two: '{0} results',
    few: '{0} results',
    many: '{0} results',
    other: '{0} results'
  },
  new_emails_count: {
    zero: 'No new emails',
    one: '{0} new email',
    two: '{0} new emails',
    few: '{0} new emails',
    many: '{0} new emails',
    other: '{0} new emails'
  },

  /* Pagination */
  pagination_page_of: 'Page {0} of {1}',
  pagination_next: 'Next',
  pagination_prev: 'Previous',

  /* Miscellaneous */
  x_of_y: '{0} of {1}',

  // -----------------------------------------------------------------------------
  // {pkg}:{ComponentDir} entries
  // -----------------------------------------------------------------------------

  /* core:Link */
  preview_link_arrow_navigation: 'Arrow left or right for link options',

  /* core:SkipLinks */
  go_to_main_content: 'Go to main content',

  /* core:AppShell */
  app_shell_create: 'Create',
  app_shell_open_nav: 'Open navigation menu',

  /* core:ComboBox */
  combobox_open_close: 'Arrow down to open, press escape to close.',
  combobox_search_instructions: 'Start typing to search',
  combobox_open_list_button_a11y: 'Open combobox list',
  combobox_close_list_button_a11y: 'Close combobox list',

  /* core:Menu */
  menu_selection_instructions: 'Press enter to select items.',
  menu_item_expand_arrow: 'Arrow right to expand.',
  menu_item_collapse_arrow: 'Arrow left to collapse.',
  menu_item_collapse_shift_space: 'Press shift space to collapse.',
  menu_item_shift_space_expand_collapse: 'Press shift space to expand and collapse.',

  /* core:Modal */
  modal_minimize: 'Minimize modal',
  modal_maximize: 'Maximize modal',
  modal_dock: 'Dock Modal',
  modal_close: 'Close modal',

  /* core:Datetime */
  selected_date_a11y: 'Selected date:',
  open_calendar_button_a11y: 'Open calendar',
  close_calendar_button_a11y: 'Close calendar',
  open_time_button_a11y: 'Open time picker',
  close_time_button_a11y: 'Close time picker',
  picker_next_month: 'Next month',
  picker_prev_month: 'Previous month',
  picker_jump_to_month: 'Jump to month',
  calendar_assist: 'Use cursor keys to navigate dates',

  /* core:Boolean */
  boolean_display_true_label: 'Yes',
  boolean_display_false_label: 'No',

  /* core:Number */
  measured_in: 'measured in {0}',
  number_increment_value_by: 'Increment value by {0}',
  number_decrement_value_by: 'Decrement value by {0}',

  /* core:Banner */
  banner_dismiss_button_label_a11y: 'Dismiss banner',

  /* core:File */
  file_upload_text_main: 'Drag and drop or {0}',
  file_upload_text_one: 'choose file',
  file_upload_text_multiple: 'choose files',

  /* core:Location */
  my_current_location_button_a11y: 'Use my current location',
  location_input_placeholder: 'Enter a location',
  location_not_found_text: 'Location not found',
  allow_location_permissions_text:
    'To get current location, allow location permissions for this app',

  /* work:CaseView */
  utilities_summary: 'Utilities summary',
  expand_summary_panel: 'Expand summary panel',
  collapse_summary_panel: 'Collapse summary panel',
  expand_utilities_panel: 'Expand utilities panel',
  collapse_utilities_panel: 'Collapse utilities panel',

  /* work:CasePreview */
  close_preview: 'Close preview',

  /* work:Confirmation */
  confirmation_details: 'Details',
  confirmation_whats_next: "What's next",
  confirmation_open_tasks: 'Open tasks',

  /* work:Stakeholders */
  add_stakeholders: 'Add stakeholder',
  edit_stakeholder: 'Edit stakeholder',
  view_stakeholders: 'Stakeholders',
  stakeholders_role: 'Role',
  stakeholders: {
    zero: '{0} stakeholders',
    one: '{0} stakeholder',
    two: '{0} stakeholders',
    few: '{0} stakeholders',
    many: '{0} stakeholders',
    other: '{0} stakeholders'
  },

  /* work:Tags */
  edit_tags: 'Edit tags',
  tags: 'Tags',

  /* work:AppAnnouncement */
  app_announcement_dismiss_button_label_a11y: 'Hide until next update',
  app_announcement_details_list_header: 'Announcements',
  app_announcement_whats_new_button_label: "See what's new",

  /* rte:RichTextEditor */
  rte_heading_style: 'Heading style',
  rte_bold: 'Bold',
  rte_italic: 'Italic',
  rte_strike_through: 'Strike-through',
  rte_cut: 'Cut',
  rte_copy: 'Copy',
  rte_paste: 'Paste',
  rte_bulleted_list: 'Bulleted list',
  rte_numbered_list: 'Numbered list',
  rte_indent: 'Indent',
  rte_unindent: 'Unindent',
  rte_table: 'Table',
  rte_anchor: 'Anchor',
  rte_image: 'Image',
  rte_invalid_html: 'Invalid HTML',
  rte_invalid_url: 'Invalid URL',
  rte_change_text_format: 'Change text format to',
  rte_toggle_unordered_list: 'Toggle unordered list',
  rte_indent_selection: 'Indent selection',
  rte_unindent_selection: 'Unindent selection',
  rte_toolbar_instructions: 'Hit tab to enter the editor toolbar',
  rte_text_formatting_toolbar: 'Text formatting toolbar',

  /* social:Feed */
  feed_new_post: 'New post',
  feed_cancel_conversation: 'Cancel conversation',
  feed_context: 'in {0}',
  feed_liked_by: 'Liked by {0}',
  feed_likes: 'Likes',
  feed_private_post: 'Private post',
  feed_public_post: 'Public post',
  feed_recipients: 'Recipients',
  feed_edit_post: 'Edit post',
  feed_post_likes: {
    zero: 'No likes',
    one: '{0} like',
    two: '{0} likes',
    few: '{0} likes',
    many: '{0} likes',
    other: '{0} likes'
  },
  feed_attachments_added: {
    zero: 'No attachments added',
    one: '{0} attachment added',
    two: '{0} attachments added',
    few: '{0} attachments added',
    many: '{0} attachments added',
    other: '{0} attachments added'
  },
  feed_attachments_removed: {
    zero: 'No attachments removed',
    one: '{0} attachment removed',
    two: '{0} attachments removed',
    few: '{0} attachments removed',
    many: '{0} attachments removed',
    other: '{0} attachments removed'
  },
  feed_post_liked: 'Post has been liked',
  feed_post_deliked: 'Post has been deliked',
  feed_post_removed: 'Post has been removed',
  feed_reply_removed: 'Reply has been removed',
  showing_num_of_num: 'Showing {0} of {1}',

  /* cs:Chat */
  scroll_to_latest_message: 'Scroll to latest message',
  scroll_to_unread_messages: 'Scroll to unread messages',
  suggested_replies_current_of_total: 'Suggested replies {0} of {1}',
  confidence_percentage: '{0}% confidence',
  next_suggested_reply: 'Next suggested reply',
  prev_suggested_reply: 'Previous suggested reply',
  dismiss_suggested_replies: 'Dismiss suggested replies',

  /* cs:Email */
  more_count: '{0} more…',
  empty_search: 'Enter a search term',
  new_messages: 'New messages',
  earlier_transcripts: 'Earlier transcripts',
  send_label: 'Send',
  enter_message: 'Enter message',
  download: 'Download',
  close_chat_utility: 'Close chat utility',
  subject: 'Subject',
  to: 'To',
  from: 'From',
  cc: 'Cc',
  bcc: 'Bcc',
  date: 'Date',
  reply: 'Reply',
  reply_all: 'Reply all',
  auto_reply: 'Auto-Reply',
  forward: 'Forward',
  email: 'Email',
  email_message: 'Email message',
  email_filters: 'Email filters',
  unread_email_count: 'unread email count is {0}',
  priority: 'Priority',
  inbox: 'Inbox',
  insert: 'Insert',
  email_add_attachment: 'Add attachment, the maximum number of attachments allowed is {0}.',
  email_disable_attachment:
    'Adding attachments are disabled, the maximum number of attachments allowed is {0}.',
  email_remove_attachment: 'Remove attachment',

  /* cs:ArticleList */
  article_list_label_a11y: 'Article list',
  article_list_filter_label_a11y: 'Article lists filter',
  article_list_header_submit_label: 'Submit',

  /* cs:CallControlPanel */
  call_panel_heading: 'Pega call',
  call_panel_make_new_call: 'Make new call',
  call_panel_agent_status: 'Status',
  call_panel_pause_call_menu_item: 'Pause call',
  call_panel_resume_call_menu_item: 'Resume call',
  call_panel_mute_mic_menu_item: 'Mute microphone',
  call_panel_unmute_mic_menu_item: 'Unmute microphone',
  call_panel_call_on_hold: 'On hold {0}',
  call_panel_consult_call_menu_item: 'Consult',
  call_panel_transfer_call_menu_item: 'Transfer',
  call_panel_send_dtmf_menu_item: 'Send DTMF',
  call_panel_conference_call_menu_item: 'Conference',
  call_panel_hangup_call_menu_item: 'Hang up',
  call_panel_contacts_add_to_favorites: 'Add to favorites',
  call_panel_contacts_remove_from_favorites: 'Remove from favorites',
  call_panel_contacts_call_button_label: 'Call',
  call_panel_contacts_list_heading: 'Contacts',
  call_panel_contacts_favorites_heading: 'Favorites',
  call_panel_contacts_dial_pad_heading: 'Dial pad',
  call_panel_new_call_heading: 'New call',
  call_panel_consult_with_heading: 'Consult with',
  call_panel_conference_heading: 'Conference',
  call_panel_transfer_button_label: 'Transfer',
  call_panel_transfer_call_heading: 'Transfer call',
  call_panel_transfer_reason_label: 'Reason',
  call_panel_transfer_to_label: 'Transfer to',
  call_panel_transfer_comments_label: 'Comments',
  call_panel_transfer_call_option_label: 'Call option',
  call_panel_transfer_call_only_option: 'Call only',
  call_panel_transfer_call_and_interaction_option: 'Call and interaction',
  call_panel_merge_call_menu_item: 'Merge',
  call_panel_send_dtmf_heading: 'Send DTMF',
  call_panel_expand: 'Expand call control panel',
  call_panel_collapse: 'Collapse call control panel',

  /* cs:DialPad */
  dial_pad_keyboard: 'Dial pad keyboard',
  dial_pad_phone_number_input_label: 'Phone number input',
  dial_pad_call_button_label: 'Call {0}',

  /* cs:TaskManager */
  dismiss_case: 'Dismiss case',
  task_manager_add_task: 'Add task',
  task_manager_wrap_up: 'Wrap up',
  task_manager_tasks: 'Tasks',
  add_tasks: 'Add tasks',
  selected_tasks: 'Selected tasks',
  no_selected_tasks: 'No selected tasks',
  task_picker_close: 'Close task picker',
  task_manager_overflow_menu: 'Menu for added tasks',
  go_label: 'Go',
  go_label_a11y: 'Go to {0}',
  continue_label: 'Continue',
  continue_label_a11y: 'Continue with {0}',
  review_label: 'Review',
  review_label_a11y: 'Review {0}',
  dismiss_label: 'Dismiss',
  dismiss_label_a11y: 'Dismiss {0}',
  task_manager_search_results_empty_text: 'No tasks',
  task_manager_delete_task: 'Delete {0}',
  search_tasks: 'Search tasks…',
  task_manager_picker_add_label: {
    zero: 'No items to add',
    one: 'Add {0} new item',
    two: 'Add {0} new item',
    few: 'Add {0} new item',
    many: 'Add {0} new item',
    other: 'Add {0} new item'
  },

  /* cs:Sentiment */
  sentiment_positive: 'Positive',
  sentiment_negative: 'Negative',
  sentiment_neutral: 'Neutral',

  /* cs:IntelligentGuidance */
  expand_intelligent_guidance_button_a11y: 'Expand intelligent guidance',
  collapse_intelligent_guidance_button_a11y: 'Collapse intelligent guidance',
  no_recommendations: 'No recommendations',

  /* condition-builder:ConditionBuilder */
  condition_builder_advanced_condition_label: 'Advanced condition',
  condition_builder_advanced_condition_placeholder: 'Advanced condition',
  condition_builder_advanced_mode_button_label: 'Advanced mode',
  condition_builder_basic_mode_button_label: 'Basic mode',
  condition_builder_condition_select_info_default: 'No selection',
  condition_builder_possible_values_label: 'Values',
  condition_builder_selection_text_default: 'Select values',
  condition_builder_submit_button_label: 'Submit',
  condition_builder_add_button_label: 'Add new condition',
  condition_builder_remove_button_label: 'Remove condition',
  condition_builder_switch_banner_text:
    'Switching from Advanced mode can reset all AND/OR/NOT operators. Do you want to continue?',
  condition_builder_confirm_button_label: 'OK',
  condition_builder_empty_selection_error_text: 'No selection',
  condition_builder_compare_with: 'Compare with',
  condition_builder_compare_with_another_field: 'Another field',
  condition_builder_compare_with_relative_date: 'Relative date',
  condition_builder_compare_with_text_value: 'Text value',
  condition_builder_compare_with_numeric_value: 'Numeric value',
  condition_builder_compare_with_date_value: 'Date value',
  condition_builder_compare_with_time_value: 'Time value',
  condition_builder_invalid_time_period: 'Invalid time period',
  condition_builder_invalid_relative_date: 'Invalid relative date',
  condition_builder_invalid_value: 'Invalid value',
  condition_builder_invalid_number: 'Invalid number',
  condition_builder_date_function_year: 'Year',
  condition_builder_date_function_quarter: 'Quarter',
  condition_builder_select_placeholder: 'Select…',
  condition_builder_day_number_of_month: {
    zero: '{0}th day of the month',
    one: '{0}st day of the month',
    two: '{0}nd day of the month',
    few: '{0}rd day of the month',
    many: '{0}th day of the month',
    other: '{0}th day of the month'
  },
  condition_builder_date_function_month: 'Month',
  condition_builder_date_function_week: 'Week',
  condition_builder_date_function_day: 'Day',
  condition_builder_date_function_hour: 'Hour',
  condition_builder_date_function_month_of_year: 'Month of year',
  condition_builder_date_function_day_of_month: 'Day of month',
  condition_builder_date_function_day_of_week: 'Day of week',
  condition_builder_date_part: 'Date part',
  condition_builder_relative_dates_minute: 'Minute(s)',
  condition_builder_relative_dates_hour: 'Hour(s)',
  condition_builder_relative_dates_day: 'Day(s)',
  condition_builder_relative_dates_week: 'Week(s)',
  condition_builder_relative_dates_month: 'Month(s)',
  condition_builder_relative_dates_quarter: 'Quarter(s)',
  condition_builder_relative_dates_year: 'Year(s)',
  condition_builder_current_minute: 'Current minute',
  condition_builder_current_hour: 'Current hour',
  condition_builder_current_day: 'Current day',
  condition_builder_current_week: 'Current week',
  condition_builder_current_month: 'Current month',
  condition_builder_current_quarter: 'Current quarter',
  condition_builder_current_year: 'Current year',
  condition_builder_last_X_minutes: {
    zero: 'Current minute',
    one: 'Last minute',
    two: 'Last {0} minutes',
    few: 'Last {0} minutes',
    many: 'Last {0} minutes',
    other: 'Last {0} minutes'
  },
  condition_builder_last_X_hours: {
    zero: 'Current hour',
    one: 'Last hour',
    two: 'Last {0} hours',
    few: 'Last {0} hours',
    many: 'Last {0} hours',
    other: 'Last {0} hours'
  },
  condition_builder_last_X_days: {
    zero: 'Current day',
    one: 'Last day',
    two: 'Last {0} days',
    few: 'Last {0} days',
    many: 'Last {0} days',
    other: 'Last {0} days'
  },
  condition_builder_last_X_weeks: {
    zero: 'Current week',
    one: 'Last week',
    two: 'Last {0} weeks',
    few: 'Last {0} weeks',
    many: 'Last {0} weeks',
    other: 'Last {0} weeks'
  },
  condition_builder_last_X_months: {
    zero: 'Current month',
    one: 'Last month',
    two: 'Last {0} months',
    few: 'Last {0} months',
    many: 'Last {0} months',
    other: 'Last {0} months'
  },
  condition_builder_last_X_quarters: {
    zero: 'Current quarter',
    one: 'Last quarter',
    two: 'Last {0} quarters',
    few: 'Last {0} quarters',
    many: 'Last {0} quarters',
    other: 'Last {0} quarters'
  },
  condition_builder_last_X_years: {
    zero: 'Current year',
    one: 'Last year',
    two: 'Last {0} years',
    few: 'Last {0} years',
    many: 'Last {0} years',
    other: 'Last {0} years'
  },
  condition_builder_next_X_minutes: {
    zero: 'Current minute',
    one: 'Next minute',
    two: 'Next {0} minutes',
    few: 'Next {0} minutes',
    many: 'Next {0} minutes',
    other: 'Next {0} minutes'
  },
  condition_builder_next_X_hours: {
    zero: 'Current hour',
    one: 'Next hour',
    two: 'Next {0} hours',
    few: 'Next {0} hours',
    many: 'Next {0} hours',
    other: 'Next {0} hours'
  },
  condition_builder_next_X_days: {
    zero: 'Current day',
    one: 'Next day',
    two: 'Next {0} days',
    few: 'Next {0} days',
    many: 'Next {0} days',
    other: 'Next {0} days'
  },
  condition_builder_next_X_weeks: {
    zero: 'Current week',
    one: 'Next week',
    two: 'Next {0} weeks',
    few: 'Next {0} weeks',
    many: 'Next {0} weeks',
    other: 'Next {0} weeks'
  },
  condition_builder_next_X_months: {
    zero: 'Current month',
    one: 'Next month',
    two: 'Next {0} months',
    few: 'Next {0} months',
    many: 'Next {0} months',
    other: 'Next {0} months'
  },
  condition_builder_next_X_quarters: {
    zero: 'Current quarter',
    one: 'Next quarter',
    two: 'Next {0} quarters',
    few: 'Next {0} quarters',
    many: 'Next {0} quarters',
    other: 'Next {0} quarters'
  },
  condition_builder_next_X_years: {
    zero: 'Current year',
    one: 'Next year',
    two: 'Next {0} years',
    few: 'Next {0} years',
    many: 'Next {0} years',
    other: 'Next {0} years'
  },
  condition_builder_previous_X_minutes: {
    zero: 'Current minute',
    one: 'Previous minute',
    two: 'Previous {0} minutes',
    few: 'Previous {0} minutes',
    many: 'Previous {0} minutes',
    other: 'Previous {0} minutes'
  },
  condition_builder_previous_X_hours: {
    zero: 'Current hour',
    one: 'Previous hour',
    two: 'Previous {0} hours',
    few: 'Previous {0} hours',
    many: 'Previous {0} hours',
    other: 'Previous {0} hours'
  },
  condition_builder_previous_X_days: {
    zero: 'Current day',
    one: 'Previous day',
    two: 'Previous {0} days',
    few: 'Previous {0} days',
    many: 'Previous {0} days',
    other: 'Previous {0} days'
  },
  condition_builder_previous_X_weeks: {
    zero: 'Current week',
    one: 'Previous week',
    two: 'Previous {0} weeks',
    few: 'Previous {0} weeks',
    many: 'Previous {0} weeks',
    other: 'Previous {0} weeks'
  },
  condition_builder_previous_X_months: {
    zero: 'Current month',
    one: 'Previous month',
    two: 'Previous {0} months',
    few: 'Previous {0} months',
    many: 'Previous {0} months',
    other: 'Previous {0} months'
  },
  condition_builder_previous_X_quarters: {
    zero: 'Current quarter',
    one: 'Previous quarter',
    two: 'Previous {0} quarters',
    few: 'Previous {0} quarters',
    many: 'Previous {0} quarters',
    other: 'Previous {0} quarters'
  },
  condition_builder_previous_X_years: {
    zero: 'Current year',
    one: 'Previous year',
    two: 'Previous {0} years',
    few: 'Previous {0} years',
    many: 'Previous {0} years',
    other: 'Previous {0} years'
  },
  condition_builder_time_period_label: 'Time period',
  condition_builder_time_period_last: 'Last',
  condition_builder_time_period_current: 'Current',
  condition_builder_time_period_previous: 'Previous',
  condition_builder_time_period_next: 'Next',
  condition_builder_value_label: 'Value',

  /* build:AppShell */
  dev_mode: 'Dev mode',
  expand_navigation: 'Expand navigation',
  collapse_navigation: 'Collapse navigation',

  /* build:Lifecycle */
  parallel: 'Parallel',
  stage: 'Stage',
  alternate_stage: 'Alternate stage',
  stage_see_full_lifecycle: 'See full lifecycle',
  lifecycle: '{0} lifecycle',
  add_stage: 'Add stage',
  add_alternate_stage: 'Add alternate stage',

  /* build:FlowModeller */
  add_node: 'Add node',
  search_nodes: 'Search nodes',

  /* build:Workbench */
  zoom_level: 'Zoom level'
};
